import { LoadingRows as BaseLoadingRows } from 'components/Loader/styled'
import styled from 'styled-components'

import { ReactComponent as Search } from '../../assets/svg/icons/Search.svg'
import { AutoColumn } from '../Column'
import { RowBetween } from '../Row'

export const TextDot = styled.div`
  height: 3px;
  width: 3px;
  background-color: ${({ theme }) => theme.deprecated_text2};
  border-radius: 50%;
`

export const Checkbox = styled.input`
  border: 1px solid ${({ theme }) => theme.deprecated_red3};
  height: 20px;
  margin: 0;
`

export const PaddedColumn = styled(AutoColumn)`
  padding: 20px;
`

export const MenuItem = styled(RowBetween)`
  padding: 8px;
  height: 52px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  grid-gap: 12px;
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  pointer-events: ${({ disabled }) => disabled && 'none'};
  :hover {
    background-color: ${({ theme, disabled }) => !disabled && theme.hoverState};
  }
  opacity: ${({ disabled, selected }) => (disabled || selected ? 0.5 : 1)};
  border-radius: 12px;
  margin-bottom: 0;
`

export const SearchInputWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
`

export const SearchIcon = styled(Search)`
  height: 20px;
  width: 20px;
  margin-right: 16px;
  position: absolute;
  left: 8px;
  fill: ${({ theme }) => theme.textSecondary};
  z-index: 100;
`

export const SearchInput = styled.input`
  position: relative;
  display: flex;
  padding: 8px 8px 8px 36px;
  height: 36px;
  align-items: center;
  width: 100%;
  white-space: nowrap;
  background: ${({ theme }) => theme.cardSecondary};
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  outline: none;
  border-radius: 6px;
  color: ${({ theme }) => theme.textPrimary};
  border-style: solid;
  -webkit-appearance: none;

  font-size: 12px;

  ::placeholder {
    color: #64748b;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  transition: border 100ms;
  :focus {
    border: 1px solid ${({ theme }) => theme.deprecated_primary1};
    outline: none;
  }
`
export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.cardBorderSecondary};
  margin: 20px 0;
`

export const SeparatorDark = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.deprecated_bg3};
`

export const LoadingRows = styled(BaseLoadingRows)`
  grid-column-gap: 0.5em;
  grid-template-columns: repeat(12, 1fr);
  max-width: 960px;
  padding: 12px 20px;

  & > div:nth-child(4n + 1) {
    grid-column: 1 / 8;
    height: 1em;
    margin-bottom: 0.25em;
  }
  & > div:nth-child(4n + 2) {
    grid-column: 12;
    height: 1em;
    margin-top: 0.25em;
  }
  & > div:nth-child(4n + 3) {
    grid-column: 1 / 4;
    height: 0.75em;
  }
`
